/**
 * Polyfills for Wagtail's admin.
 */

// IE11.
import 'core-js/shim';
// IE11, old iOS Safari.
import 'whatwg-fetch';
// IE11.
import 'element-closest';



// WEBPACK FOOTER //
// ./client/src/utils/polyfills.js